import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND}/api`,
    withCredentials: true,
});

// Attach token from localStorage as a fallback (cookie is primary)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("gd_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
